// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3368) return "static/chunks/3368-ae49d4bccd064a2c.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1526":"f54dd98a43ef6bb6","4998":"0be0ff1933de8b72","5791":"e5d3ed4e2b0dbeab"}[chunkId] + ".js";
};